import { render, staticRenderFns } from "./ArchivedAlert.vue?vue&type=template&id=5f48b083"
import script from "./ArchivedAlert.vue?vue&type=script&lang=js"
export * from "./ArchivedAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports